import {IndexingState} from '../indexing/store/indexing.reducer'
import {RootState} from './types'

export const selectIndexingState = (state: RootState): IndexingState => state.indexing
